import { render, staticRenderFns } from "./ShowDialogNoticia.vue?vue&type=template&id=2fe5f16c&scoped=true"
import script from "./ShowDialogNoticia.vue?vue&type=script&lang=js"
export * from "./ShowDialogNoticia.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogNoticia.vue?vue&type=style&index=0&id=2fe5f16c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5f16c",
  null
  
)

export default component.exports